import React from 'react';
import HeaderDescription from "@/components/common/Header&Description";
import {getCssSizeValue, getHtmlFromRedactorField, getPaddingsClassFromData, getPropSafely} from "@/utils/utils";
import CommonGridContainer from "@/components/common/GridContainer";
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";
import useColor from "@/hooks/useColor";
import {CONTENT_TYPES} from "@/constants";
import Text from "@/components/common/Text";
import GridContainerRectangles from "@/components/common/GridContainerRectangles";
import Icon1 from '../../assets/grid_background_icons/Wolontariat_ilustracja_serce_1.svg';
import Icon2 from '../../assets/grid_background_icons/Wolontariat_ilustracja_bez.svg';
import Icon3 from '../../assets/grid_background_icons/Wolontariat_ilustracja_okrag.svg';
import Image from "@/components/common/Image";
import {useIsMobile, useIsTablet} from "@/hooks/useDevice";
import useFilterData from "@/hooks/useFIlterData";

const GridContainer = styled(CommonGridContainer)`
    background-color: ${({ $bgColor }) =>  $bgColor ? $bgColor :  'unset'};
	&.image-variant {
		padding-top: ${getCssSizeValue(55, BREAKPOINTS.MOBILE)};
		padding-bottom: 0;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
			padding-top: ${getCssSizeValue(55, BREAKPOINTS.TABLET)};
			padding-bottom: 0;
		}
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
            //padding-top: ${getCssSizeValue(120, BREAKPOINTS.DESKTOP)};
			align-items: start;
			padding-top: 0;
            padding-bottom: ${getCssSizeValue(165, BREAKPOINTS.DESKTOP)};
        }
		
		* {
			color: ${({theme}) => theme.colors.white}!important;
		}
	}
	&.spot-image-variant {
		position: relative;
		min-height: calc(50vw / 1.5);
		padding-top: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
		padding-bottom: ${getCssSizeValue(49, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
			margin-top: ${getCssSizeValue(70, BREAKPOINTS.TABLET)};
			padding-top: ${getCssSizeValue(65, BREAKPOINTS.MOBILE)};
			min-height: calc(50vw / (3/4));
		}
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
            padding-top: ${getCssSizeValue(112, BREAKPOINTS.DESKTOP)};
            padding-bottom: ${getCssSizeValue(165, BREAKPOINTS.DESKTOP)};
			min-height: calc(50vw / 1.5);
        }
	}
	&.grey {
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			padding-top: ${getCssSizeValue(150, BREAKPOINTS.DESKTOP)};
			padding-bottom: ${getCssSizeValue(132, BREAKPOINTS.DESKTOP)};
		}
	}
	&.icons-grid {
		position: relative;
		min-height: 300vw; // / 12.5 * 24
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
			min-height: calc((100vw / 8) * 10);
		}
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			min-height: calc(100vw / 2); // / 16 * 8
			align-items: center;
		}
	}
`

const FullwidthWrapper = styled.div`
	background-color: ${({theme}) => theme.colors.antiflashWhite};
	width: 100%;
	position: relative;
	margin-top: calc(100vw / 1.5);
	padding-top: ${getCssSizeValue(105, BREAKPOINTS.MOBILE)};
	padding-bottom: ${getCssSizeValue(70, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		margin-top: 0;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: 100%;
		padding-top: 0;
		padding-bottom: 0;
	}
	span[style= "text-decoration: line-through;"] {
		display: inline-block;
	}
`

const GraphicContainer = styled.img`
	position: absolute;
	right: 0;
	top: -87px;
	bottom: unset;
	width: 146px;
	//height: 100%;
	z-index: 2;
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		width: 50vw;
		bottom: 0;
		top: unset;
		height: 200%;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		right: 0;
		bottom: 0;
		width: unset;
		height: 200%;
	}
`

const ImageContainer = styled.div`
	margin-top: ${getCssSizeValue( 16, BREAKPOINTS.MOBILE)};
	width: calc(100% + var(--paddingX));
	margin-left: calc(-1 * (var(--paddingX)));
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		margin-top: ${getCssSizeValue( 55, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: calc(100% + var(--paddingX));
		margin-left: calc(-1 * (var(--paddingX)));
		margin-top: 0;
	}
`

const StyledHeaderAndDescription = styled(HeaderDescription)`
	display: flex;
	--grid-column-start: 1;
    grid-column: var(--grid-column-start) / min(calc(var(--grid-column-start) + var(--local-size)), calc(var(--grid-count) + 1));
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        --grid-column-start: ${({ $columnStart }) => $columnStart || 1};
    }
`

const BackgroundGrid = styled(GridContainerRectangles)`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	grid-template-columns: repeat(8, 1fr);
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		grid-template-columns: repeat(16, 1fr);
	}
	.icon {
		position: absolute;
		width: calc(100vw / 8);
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			width: calc(100vw / 16);
		}
	}
	.icon-1 {
		top: calc(100vw * 3 / 8);
		left: 0;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			top: calc(100vw * 3 / 16);
			left: 0;
		}
	}	
	.icon-2 {
		top: calc(100vw * 9 / 8);
		right: 0;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
			top: calc(100vw * 5 / 8);
		}
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			top: calc(100vw * 5 / 16);
			right: calc(100vw / 16);
		}
	}	
	.icon-3 {
		top: calc(100vw * 10 / 8);
		right: 0;
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
			top: calc(100vw * 6 / 8);
		}
		@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			top: calc(100vw * 6 / 16);
			right: calc(100vw / 16);
		}
	}
`

const RightImageWrapper = styled.div`
	width: 100vw;
	position: absolute;
	right: 0;
	top: calc(-1 * (100vw / 1.5));
	aspect-ratio: 3/2;
	.image {
		width: 100%;
		aspect-ratio: 3/2;
	}
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		display: none;
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		display: none;
	}
`

//TODO: list all pairs
const TYPO_COLORS = {
	platinum: 'richBlack',
	richBlue: 'white',
}

const HeaderAndDescriptionModule = ({ data, isPreview }) => {
	const paddings = getPaddingsClassFromData(data)
	const headerDescription = data?.headerDescription || {}
	const id = data?.id || ''
	const columnStart = parseInt(data?.columnStart || '1')
	const bgCl = data?.backgroundColor?.color || ''
	const bgColor = useColor(bgCl)
	const typoColor = useColor(TYPO_COLORS[bgCl])
	const isMobile = useIsMobile();
	const isTablet = useIsTablet();
	const isVariantImage = headerDescription?.__typename === CONTENT_TYPES.HEADER_DESCRIPTION_AND_IMAGE_BLOCK;
	const isVariantSpotImage = headerDescription?.__typename === CONTENT_TYPES.HEADER_DESCRIPTION_AND_SPOT_IMAGE_BLOCK;
	const isVariantIconsGrid = headerDescription?.__typename === CONTENT_TYPES.HEADER_DESCRIPTION_AND_ICONS_GRID_BLOCK;
	const rectanglesAmount = isMobile && !isTablet ? 192 : isTablet ? 80 : 128;
	// PREVIEW SECTION
	const allHeaderDescription = getPropSafely(data, 'allHeaderDescription', [])
	const contextData = useFilterData(allHeaderDescription, false);
	const headerDescriptionPreview = contextData?.headerDescription || {};
	const isVariantImagePreview = headerDescriptionPreview?.__typename === CONTENT_TYPES.HEADER_DESCRIPTION_AND_IMAGE_BLOCK;
	const isVariantSpotImagePreview = headerDescriptionPreview?.__typename === CONTENT_TYPES.HEADER_DESCRIPTION_AND_SPOT_IMAGE_BLOCK;
	const isVariantIconsGridPreview = headerDescriptionPreview?.__typename === CONTENT_TYPES.HEADER_DESCRIPTION_AND_ICONS_GRID_BLOCK;
	return (
		<>
			{!isPreview && (
				<>
					<GridContainer
						id={id}
						key={id}
						className={`${paddings} no-margin padding ${isVariantImage ? 'image-variant' : ''} ${isVariantSpotImage ? 'spot-image-variant' : ''}${isVariantIconsGrid ? 'icons-grid' : ''}`}
						$bgColor={bgColor}>
						{isVariantImage && !isMobile && !isTablet && <ImageContainer className='col-desktop-5 col-tablet-4 col-mobile-3'>
							<img
								src={headerDescription?.image?.image?.url || ''}
							/>
						</ImageContainer>}
						{isVariantIconsGrid && (
							<BackgroundGrid id={id} key={id} className={`${paddings} no-margin ${isVariantImage ? 'image-variant' : ''} ${isVariantSpotImage ? 'spot-image-variant' : ''}`} $bgColor={bgColor}>
								{[...new Array(rectanglesAmount)].map((_, key) => <div className='grid-item' key={`block-${key}`}/>)}
								<Icon1 className='icon icon-1'/>
								<Icon2 className='icon icon-2'/>
								<Icon3 className='icon icon-3'/>
							</BackgroundGrid>
						)}
						<StyledHeaderAndDescription data={headerDescription} className={`${isVariantSpotImage ? 'spot-image' : ''} border-top`} color={typoColor} indent $columnStart={columnStart} />
						{isVariantImage && (isMobile || isTablet) && <ImageContainer className='col-desktop-5 col-tablet-4 col-mobile-3'>
							<img
								src={headerDescription?.image?.image?.url || ''}
							/>
						</ImageContainer>}
					</GridContainer>
					{isVariantSpotImage && <FullwidthWrapper>
						<RightImageWrapper className='col-mobile-8 col-tablet-4 col-desktop-8'>
							<Image src={headerDescription?.spotImage?.url || ''} sizes="100%" fit="cover"/>
						</RightImageWrapper>
						<GridContainer className='grey indent-desktop-1'>
							<Text tag="div" className="col-desktop-9 col-tablet-4 col-mobile-8 typo-borna typo-borna-90 description" dangerouslySetInnerHTML={getHtmlFromRedactorField(headerDescription.secondHeader)}/>
						</GridContainer>
						<GraphicContainer src={headerDescription?.graphic?.url || ''}/>
					</FullwidthWrapper>}
				</>
			)}
			{contextData && isPreview && (
				<>
					<GridContainer
						id={id}
						key={id}
						className={`${paddings} no-margin padding ${isVariantImagePreview ? 'image-variant' : ''} ${isVariantSpotImagePreview ? 'spot-image-variant' : ''}${isVariantIconsGridPreview ? 'icons-grid' : ''}`}
						$bgColor={bgColor}>
						{isVariantImagePreview && !isMobile && !isTablet && <ImageContainer className='col-desktop-5 col-tablet-4 col-mobile-3'>
							<img
								src={headerDescriptionPreview?.image?.image?.url || ''}
							/>
						</ImageContainer>}
						{isVariantIconsGridPreview && (
							<BackgroundGrid id={id} key={id} className={`${paddings} no-margin ${isVariantImagePreview ? 'image-variant' : ''} ${isVariantSpotImagePreview ? 'spot-image-variant' : ''}`} $bgColor={bgColor}>
								{[...new Array(rectanglesAmount)].map((_, key) => <div className='grid-item' key={`block-${key}`}/>)}
								<Icon1 className='icon icon-1'/>
								<Icon2 className='icon icon-2'/>
								<Icon3 className='icon icon-3'/>
							</BackgroundGrid>
						)}
						<StyledHeaderAndDescription data={headerDescriptionPreview} className={`${isVariantSpotImagePreview ? 'spot-image' : ''} border-top`} color={typoColor} indent $columnStart={columnStart} />
						{isVariantImagePreview && (isMobile || isTablet) && <ImageContainer className='col-desktop-5 col-tablet-4 col-mobile-3'>
							<img
								src={headerDescription?.image?.image?.url || ''}
							/>
						</ImageContainer>}
					</GridContainer>
					{isVariantSpotImagePreview && <FullwidthWrapper>
						<RightImageWrapper className='col-mobile-8 col-tablet-4 col-desktop-8'>
							<Image src={headerDescriptionPreview?.spotImage?.url || ''} sizes="100%" fit="cover"/>
						</RightImageWrapper>
						<GridContainer className='grey indent-desktop-1'>
							<Text tag="div" className="col-desktop-9 col-tablet-4 col-mobile-8 typo-borna typo-borna-90 description" dangerouslySetInnerHTML={getHtmlFromRedactorField(headerDescription.secondHeader)}/>
						</GridContainer>
						<GraphicContainer src={headerDescriptionPreview?.graphic?.url || ''}/>
					</FullwidthWrapper>}
				</>
			)}
		</>
	);
};

export default HeaderAndDescriptionModule;
